import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input_container" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = ["src"]




export default /*@__PURE__*/_defineComponent({
  __name: 'rowField',
  props: {
    labelText: {
        type: String,
        default: ''
    },
    leftImage: {
        type: String,
    },
    rightImage: {
        type: String,
    },
    isShowRightIcon: {
        type: Boolean,
        default: () => false
    },
    content: {
        type: String,
    },
    opacityNone: {
        type: Boolean,
        default: () => false
    },
    bgColor: {
        type: String,
        default: () => ''
    }
},
  emits: ['onClickRight'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const handleClick = () => {
    emits('onClickRight')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.labelText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.labelText), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_van_row, { class: "field_row" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "22",
          class: "content"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.content), 1)
          ]),
          _: 1
        }),
        (props.isShowRightIcon)
          ? (_openBlock(), _createBlock(_component_van_col, {
              key: 0,
              span: "2",
              class: "icon_image"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: __props.rightImage,
                  alt: "",
                  onClick: handleClick
                }, null, 8, _hoisted_3)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})